/**
 * Limites et features par palier d'abonnement
 * Source unique de vérité — utilisé par useSubscription + FeatureGate
 */

export const TIERS = {
  FREE: 'free',
  PRO_MONTHLY: 'pro_monthly',
  PRO_ANNUAL: 'pro_annual',
};

export const FEATURES = {
  AI_WEEK_GENERATION: 'ai_week_generation',
  AI_CHAT_UNLIMITED: 'ai_chat_unlimited',
  AI_NOTES_COMPLETION: 'ai_notes_completion',
  AUDIO_NOTES: 'audio_notes',
  VIDEO_NOTES: 'video_notes',
  VOICE_TRANSCRIPTION: 'voice_transcription',
  UNLIMITED_TASKS: 'unlimited_tasks',
  MULTI_DEVICE_SYNC: 'multi_device_sync',
  ADVANCED_STATS: 'advanced_stats',
  UNLIMITED_FOCUS: 'unlimited_focus',
  GOOGLE_CALENDAR_SYNC: 'google_calendar_sync',
  GO_SPORT_UNLIMITED: 'go_sport_unlimited',
  PRIORITY_SUPPORT: 'priority_support',
  BETA_ACCESS: 'beta_access',
  FOUNDER_BADGE: 'founder_badge',
};

export const LIMITS = {
  free: {
    tasksPerDay: 10,
    aiGenerationsPerWeek: 1,
    aiChatMessagesPerDay: 5,
    focusSessionsPerDay: 3,
    statsHistoryDays: 7,
  },
  pro: {
    tasksPerDay: Infinity,
    aiGenerationsPerWeek: Infinity,
    aiChatMessagesPerDay: Infinity,
    focusSessionsPerDay: Infinity,
    statsHistoryDays: Infinity,
  },
};

// Features disponibles selon le palier
export const TIER_FEATURES = {
  [TIERS.FREE]: new Set([]),
  [TIERS.PRO_MONTHLY]: new Set(Object.values(FEATURES)),
  [TIERS.PRO_ANNUAL]: new Set(Object.values(FEATURES)),
};

export function isPaidTier(tier) {
  return tier === TIERS.PRO_MONTHLY || tier === TIERS.PRO_ANNUAL;
}

export const PRICES = {
  monthly: {
    id: process.env.REACT_APP_STRIPE_PRO_MONTHLY || '',
    amount: 5.99,
    currency: '€',
    label: 'Pro Mensuel',
    period: '/mois',
  },
  annual: {
    id: process.env.REACT_APP_STRIPE_PRO_ANNUAL || '',
    amount: 49.99,
    currency: '€',
    label: 'Pro Annuel',
    period: '/an',
    monthlyEquivalent: 4.17,
    savings: 30,
  },
};

export const UPGRADE_REASONS = {
  [FEATURES.AI_WEEK_GENERATION]: {
    title: 'Génération IA illimitée',
    description: 'Vous avez atteint votre limite d\'1 génération par semaine. Passez Pro pour générer autant de semaines que vous voulez.',
    icon: '🤖',
  },
  [FEATURES.AI_CHAT_UNLIMITED]: {
    title: 'Chat IA illimité',
    description: 'Vous avez atteint vos 5 messages quotidiens. Passez Pro pour un chat IA sans limite.',
    icon: '💬',
  },
  [FEATURES.AUDIO_NOTES]: {
    title: 'Notes audio',
    description: 'Les notes audio et vidéo sont une fonctionnalité Pro. Enregistrez votre voix et vos idées sans limites.',
    icon: '🎤',
  },
  [FEATURES.VIDEO_NOTES]: {
    title: 'Notes vidéo',
    description: 'Enregistrez des notes vidéo pour capturer vos idées visuellement. Disponible en Pro.',
    icon: '🎥',
  },
  [FEATURES.VOICE_TRANSCRIPTION]: {
    title: 'Transcription vocale',
    description: 'La transcription temps réel est une fonctionnalité Pro. Dictez vos notes, l\'app les écrit pour vous.',
    icon: '📝',
  },
  [FEATURES.UNLIMITED_TASKS]: {
    title: 'Tâches illimitées',
    description: 'Vous avez atteint la limite de 10 tâches par jour. Passez Pro pour des tâches illimitées.',
    icon: '📋',
  },
  [FEATURES.ADVANCED_STATS]: {
    title: 'Statistiques avancées',
    description: 'Accédez à votre historique complet et à des analyses détaillées de votre productivité.',
    icon: '📊',
  },
  [FEATURES.MULTI_DEVICE_SYNC]: {
    title: 'Synchronisation multi-appareils',
    description: 'Accédez à vos données depuis tous vos appareils en temps réel.',
    icon: '🔄',
  },
};
